import React from 'react';
import { motion } from 'framer-motion';
export function NumbersSlide() {
  return <div className="h-full flex items-center justify-center -mt-4" data-id="element-255">
      <motion.div initial={{
      opacity: 0,
      scale: 0.97
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5
    }} className="max-w-4xl max-h-[85%] overflow-hidden" data-id="element-256">
        <img src="https://cdn.magicpatterns.com/uploads/ni6Gxeg3ptUXh96JSDi1r6/image.png" alt="Invoiced Revenue Forecast 2026: DKK 560K 2025 revenue, DKK 3.46M without investment, DKK 5.82M with investment, +DKK 2.36M uplift. Monthly breakdown with chart and table." className="w-full h-full object-contain object-center" data-id="element-257" />
      </motion.div>
    </div>;
}